import { BaseCardWrapper } from '@healthhub/react-ui';
import { Typography } from 'antd';
import type { KeyboardEvent } from 'react';
import { useNavigate } from 'react-router';

import { OutlinedRightArrowIcon } from '@shared/assets-icon';
import { Button } from '@shared/components';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';
import useMemberIdentifier from '@shared/hooks/useMemberIdentifier';

const { Text } = Typography;

interface LookForEServiceCardProps {
  description: string;
  icon: string;
  label: string;
  onClick?: () => void;
  publicDescription?: string;
  publicUrl?: string;
  url?: string;
}

const LookForEServiceCard = ({
  description,
  icon,
  label,
  onClick,
  publicDescription,
  publicUrl,
  url,
}: LookForEServiceCardProps) => {
  const navigate = useNavigate();
  const { memberIdentifier } = useMemberIdentifier();
  const { isAuthenticated } = useIsAuthenticated();

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (publicUrl) {
      navigate(publicUrl);
    }
  };

  const onClickCard = () => {
    if (onClick) {
      onClick();
    } else {
      navigate({
        pathname: url ?? '',
        search: memberIdentifier ? `?mid=${memberIdentifier}` : '',
      });
    }
  };

  const onKeyDownCard = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClickCard();
    }
  };

  return (
    <div onClick={onClickCard} onKeyDown={onKeyDownCard} role="button" tabIndex={0}>
      <BaseCardWrapper className="h-full rounded-lg p-4 shadow-portal-card lg:min-h-28">
        <div className="flex items-start gap-1.5">
          <img alt="" className="size-10px" src={icon} />
          <div className="flex flex-1 flex-col gap-2.5">
            <div className="flex flex-col">
              <Text className="text-base font-semibold text-primary-blue-grey" lang="en">
                {label}
              </Text>
              <Text className="text-xs font-medium text-functional-iron" lang="en">
                {description}
              </Text>
            </div>
            {!isAuthenticated && !!publicDescription && (
              <Button
                className="text-xs font-medium text-primary-green-4 underline"
                onClick={onButtonClick}
                tabIndex={0}
                variant="link"
              >
                {publicDescription}
              </Button>
            )}
          </div>
          <OutlinedRightArrowIcon className="size-6px [&_path]:stroke-primary-green-4" />
        </div>
      </BaseCardWrapper>
    </div>
  );
};

export default LookForEServiceCard;
